import React from 'react';
import PropTypes from 'prop-types';
import { createRefetchContainer, graphql } from 'react-relay';

import { SbSharedFollowSearchBanner } from '../SbSharedFollowSearchBanner/SbSharedFollowSearchBanner';

const SbRespFollowSearchBannerComponent = props => {
    const { viewer, refetchFollow, ...otherProps } = props;

    if (!viewer.isSbRespFollowSearchEnabled) {
        return null;
    }

    return <SbSharedFollowSearchBanner {...otherProps} onFollowSearchCompleted={refetchFollow} />;
};

SbRespFollowSearchBannerComponent.propTypes = {
    viewer: PropTypes.object.isRequired,
    refetchFollow: PropTypes.func.isRequired,
};

export const SbRespFollowSearchBanner = createRefetchContainer(SbRespFollowSearchBannerComponent, {
    viewer: graphql`
        fragment SbRespFollowSearchBanner_viewer on Viewer {
            isSbRespFollowSearchEnabled: isEnabledByLocale(featureName: "NON_MVP_SEARCH_BROWSE")
        }
    `,
    user: graphql`
        fragment SbRespFollowSearchBanner_user on User {
            ...SbSharedFollowSearchBanner_user
        }
    `,
});
